import axios from 'axios'
import axiosCacheDecorator from '@/utils/axiosCacheDecorator'
import { REQUEST_TIMEOUT } from '@/utils/consts'

const appJson = 'application/json'
export const CACHE_KEY_HEADER = 'x-hkld-disk-cache'
export const XSRF = 'X-XSRF-Token'
export const USER_DOMAIN_HEADER = 'X-USER-DOMAIN'
export const SESSION_ID_HEADER = 'x-hkld-session-id'
export const xsrfCookieName = 'xsrftoken'
export const globalXSRFCookieName = 'pmsr-global-csrf-token'

export const axiosDefaults = {
  baseURL: process.env.API_PREFIX,
  headers: {
    'Content-Type': appJson,
    Accept: appJson,
  },
  maxRedirects: 0,
  withCredentials: true,
  timeout: REQUEST_TIMEOUT,
  adapter: axiosCacheDecorator(axios.defaults.adapter),
}

export const baseURL = axiosDefaults.baseURL
